<script>
import BaseDotSpinner from '../spinner/BaseDotSpinner'
import TextLoader from './TextLoader'

export default {
  name: 'BaseLoader',
  props: {
    containerTag: {
      type: String,
      default: 'div'
    },
    containerProps: {
      type: Object,
      default: () => ({class: 'content'})
    }
  },
  render (createElement) {
    return createElement(
      this.containerTag,
      {...this.containerProps},
      [createElement(BaseDotSpinner), createElement(TextLoader)]
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/loader/BaseLoader.vue